import { Button, IconButton, IconNames, Tooltip } from '@dixa/lib-shared-habla';
import { ReactNode } from 'react';

import styles from '../copilotPinnedActions.module.scss';

type PinnedActionButtonProps = {
  icon: IconNames;
  label: string;
  tooltip?: ReactNode;
  collapsed?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

/** A pinned copilot action, labelled or reduced to its icon. */
export const PinnedActionButton = ({
  icon,
  label,
  tooltip,
  collapsed,
  disabled,
  onClick,
}: PinnedActionButtonProps): JSX.Element => {
  // IconButton is the same Button with its label dropped, so collapsing changes
  // the width without changing the styling.
  const button = collapsed ? (
    <IconButton
      variant="secondary"
      icon={icon}
      disabled={disabled}
      onClick={onClick}
    />
  ) : (
    <Button
      variant="secondary"
      icon={icon}
      disabled={disabled}
      onClick={onClick}
      className={styles.button}
    >
      {label}
    </Button>
  );

  if (!tooltip) {
    return button;
  }

  // The tooltip's own wrapper is the hover target, so it still shows while the
  // button is disabled and has pointer-events: none.
  return <Tooltip content={tooltip}>{button}</Tooltip>;
};
